/*jshint esversion: 6 */

(function singleimageScript($, Drupal) {
  "use strict";
  Drupal.behaviors.singleimage = {
    attach(context) {
      $(window).on("load", function() {
        var $images = $(".single-image");
        $images.each(function() {
          var $image = $(this).find("img");
          var $imageWidth = $image.width();
          $(this).css("max-width", $imageWidth + "px");
        });
      });
    }
  };
})(jQuery, Drupal);
